module.exports = __webpack_public_path__ + "static/img/d6.dbc8f6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/d6.png
// module id = YQgU
// module chunks = 0